import { useRouter } from 'next/router';

import { WEB_URL } from '~constant/env';
import NudgeLoginDialog from '~features/company/NudgeLoginDialog';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import useGetMyInfoQuery from '~hooks/query/user/useMyInfoQuery';
import useMoveOneIdPage from '~hooks/useMoveOneIdPage';
import { useRouterQuery } from '~hooks/useRouterQuery';

import { Item, ItemList, Wrapper } from '../SkillLIst/style';
import * as S from './style';

const data = [
  { id: 1, name: '????' },
  { id: 2, name: '????' },
  { id: 3, name: '????' },
  { id: 4, name: '????' },
  { id: 5, name: '????' },
  { id: 6, name: '????' },
  { id: 7, name: '????' },
  { id: 8, name: '????' },
  { id: 9, name: '????' },
];

function NudgeLoginSection() {
  const router = useRouter();
  const companyHash = useRouterQuery('companyId');
  const { data: companyInfo } = useGetCompanyInfo(companyHash);
  const { isActiveUser } = useGetMyInfoQuery();
  const moveOneIdPage = useMoveOneIdPage();

  const handleClick = () => {
    if (isActiveUser) {
      return router.push(
        `/review/skill?companyHash=${companyHash}&beforeUrl=${WEB_URL}${router.asPath}#company-review-chart`,
      );
    }
    moveOneIdPage({
      beforeUrl: `${WEB_URL}${router.asPath}#company-review-chart`,
      messageKey: 'kreditjob_company_bookmark_title',
    });
  };

  return (
    <Wrapper
      onClick={handleClick}
      data-attribute-id='company__review__write__click'
      data-is-review-exist='false'
      data-company-hash={companyInfo?.PK_NM_HASH}
      data-company-name={companyInfo?.name}
      data-review-type={'skill'}
      data-is-blur='true'>
      <NudgeLoginDialog
        inlineCss={S.cssNudgeDialog}
        message={
          <>
            {companyInfo?.name}에서
            <br />
            사용하는 기술과 툴이 궁금하다면?
          </>
        }
        buttonText='리뷰하기'
      />
      <ItemList>
        {data.map((item) => (
          <Item key={item.id}>{item.name}</Item>
        ))}
      </ItemList>
    </Wrapper>
  );
}

export default NudgeLoginSection;
